import React, {useState } from 'react'
import {Form, Button, Col } from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import FormContainer from '../components/FormContainer'
import { savePaymentMethod }  from '../actions/cartActions'
import CheckoutSteps from '../components/CheckoutSteps'
import { Helmet } from 'react-helmet-async'
//import { savePaymentMethod } from '../actions/cartActions '

function PaymentScreen({ history }) {

    const cart = useSelector(state => state.cart)
    const { shippingAddress } = cart
    
    const dispatch = useDispatch()

    const [paymentMethod, setPaymentMethod] = useState('PayPal')


    if (!shippingAddress.address) {
        history.push('/shipping')
        
    }

    const submitHandler = (e) => {
        e.preventDefault()
        dispatch(savePaymentMethod(paymentMethod))
        history.push('/placeorder')
    }

  return (
    <FormContainer>
        <Helmet>
          <meta name="robots" content="noindex, follow" />
        </Helmet>
      <CheckoutSteps step1 step2 step3/>
        <Form onSubmit={submitHandler}>
            <Form.Group>
                <Form.Label as='legend'>Metodo di pagamento</Form.Label>
                <Col>
                    <Form.Check
                        type='radio'
                        label='Paypal o Carta di credito'
                        id='paypal'
                        name='paymentMethod'
                        checked
                        onChange={(e) => setPaymentMethod(e.target.value)}
                    >
                    </Form.Check>
                </Col>
            </Form.Group>

            <br></br>

            <Button type='submit' variant='primary'>
                Continua
            </Button>

        </Form>
    </FormContainer>
  )
}

export default PaymentScreen